<div class="global-wrapper landing">

  <!--BEGIN header-->
  <header class="header">
    <div class="container">
      <div class="container__box header__box">
        <div class="header__logo d-block">
          <app-logo></app-logo>
        </div>
      </div>
    </div>
  </header>
  <!--END header-->

  <div class="global-wrapper-inner">
    <!--BEGIN promo-section-->
    <section class="promo-section">
      <div class="container promo-section__container">
        <div class="promo-section__left">
          <h1 class="h1 promo-section__title">
            Керуйте логістикою у Бізнес-кабінеті «Нова Пошта»
          </h1>

          <p class="promo-section__text">
            Зареєструйтеся у Бізнес-кабінеті та керуйте вашими посилками.
            Замовляйте додаткові послуги та сплачуйте за них.
          </p>

          <div class="promo-section__buttons">
            <button mat-raised-button
                    color="primary"
                    class="mr-2 text-transform-none promo-section__btn box-shadow-none"
                    (click)="registerNewAccount()">
              Зареєструватися
            </button>

            <button mat-stroked-button
                    color="accent"
                    [matMenuTriggerFor]="menu">
              Увійти
              <mat-icon matSuffix>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu" class="promo-section__menu">
              <a [routerLink]="[AppRoutes.auth, AppRoutes.login_organization]"
                 mat-menu-item>
                як юридична особа
              </a>
              <a [routerLink]="[AppRoutes.auth, AppRoutes.login_private]"
                 mat-menu-item>
                як приватна
              </a>
            </mat-menu>
          </div>
        </div>

        <div class="promo-section__right">
          <img class="promo-section__img"
               src="assets/images/landing/img_cbc_landing_1-1.png"
               alt="Business Cabinet Nova Poshta">
        </div>
      </div>
    </section>
    <!--END promo-section-->

    <!--BEGIN feature-section-->
    <section class="advantages-section" id="advantages">
      <div class="container">
        <div class="container__box">
          <ul class="advantages-list">
            <li *ngFor="let advantage of Advantages" class="advantages-list__item">
              <div class="advantages-list__info">
                <img [src]="advantage.img.url"
                     [alt]="advantage.img.alt"
                     class="advantages-list__icon">
                <h3 class="h3 advantages-list__title">{{advantage.heading}}</h3>
                <p class="advantages-list__text">{{advantage.description}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!--END feature-section-->

    <!--BEGIN question-section-->
    <section class="question-section" id="questions">
      <div class="container">
        <div class="container__box">
          <h2 class="h1 question-section__title">Питання та вiдповiдi</h2>
          <ul class="accordion question-section__accordion">
            <li class="accordion__item"
                *ngFor="let item of accordionObject.data"
                [class.accordion__item--open]="accordionObject.selected === item"
                (click)="accordion(item)">
              <div class="accordion__text">{{item.text}}</div>
              <div class="accordion__content">{{item.content}}</div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!--END question-section-->

    <!--BEGIN promo-section-->
    <section class="promo-section promo-section--bg">
      <div class="container promo-section__container">
        <div class="promo-section__left">
          <h2 class="h1 promo-section__title">
            Зареєструйтесь у Бізнес-кабінеті та розпочніть керування посилками
          </h2>
          <div class="promo-section__buttons">
            <a (click)="registerNewAccount()" class="btn promo-section__btn">Зареєструватися</a>
          </div>
        </div>
        <div class="promo-section__right">
          <img class="promo-section__img"
               src="assets/images/landing/img_cbc_landing_2-1.png"
               alt="Statistics">
        </div>
      </div>
    </section>
    <!--END promo-section-->
  </div>
  <!--BEGIN footer-->

  <footer class="footer">
    <div class="container">
      <div class="container__box footer__box">
        <div class="footer__item">
          <div class="copyright">
            <div class="copyright__text">
              &copy; 2006–{{today | date:'yyyy'}} ТОВ «Нова Пошта»
            </div>
            <a href="https://novaposhta.ua/news/rubric/2"
               target="_blank"
               class="copyright__link">Новини компанії
            </a>
            <div class="copyright__hint">Усі права захищені.
              Використання матеріалів цього сайту
              можливе тільки з посиланням на джерело.
            </div>
          </div>
        </div>
        <div class="footer__item">
          <div class="footer__label">Мобільний додаток</div>
          <ul class="apps">
            <li class="apps__item">
              <a href="http://bit.ly/CBC_Android"
                 target="_blank"
                 class="apps__link">
                <img src="assets/images/landing/icons/android.svg"
                     alt="Android"
                     class="apps__icon">
              </a>
            </li>
            <li class="apps__item">
              <a href="https://click.google-analytics.com/redirect?tid=UA-47304740-1&url=https%3A%2F%2Fitunes.apple.com%2Fus%2Fapp%2Fnova-posta%2Fid545980774&aid=com.novaposhta.novaposhta&idfa=%{idfa}&cs=CBC&cm=Landing&cn=cbc_landing"
                target="_blank"
                 class="apps__link">
                <img src="assets/images/landing/icons/ios.svg"
                     alt="iOS"
                     class="apps__icon">
              </a>
            </li>
            <li class="apps__item">
              <a href="https://appgallery.cloud.huawei.com/marketshare/app/C101417437?locale=uk_UA&source=appshare&subsource=C101417437"
                target="_blank"
                class="apps__link">
                <img src="assets/images/landing/icons/huawei.svg"
                     alt="Huawei"
                     class="apps__icon_hw">
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
  <!--END footer-->
</div>
